// @flow
import { createContext } from 'preact';

const ThemeConfig = createContext();

export default ThemeConfig